import { useData } from "./DataContext.js";

import { CSSTransition, TransitionGroup } from "react-transition-group";

import CharPicture from "./CharPicture.js";

export default function DialogueCharPicture (props)
{
    const gData = useData();

    let charId = null;
    let src = null;
    
    if (gData.state.currentDialogue !== null && gData.state.showModals.dialogue)
    {
	charId = gData.state.currentDialogue.charId;

	if (charId === "max")
	{
	    const placeChar = Object.values(gData.content.chars).filter((char) => char.placeId === gData.state.currentPlaceId);
	    if (placeChar[0] !== undefined) charId = placeChar[0].id;
	}

	if (charId !== null)
	{
	    const charContent = gData.content.chars[charId];
	    src = gData.gameId + "/pictures/chars/" + charContent.id + ".png";
	    if (charContent.picture !== undefined) src = gData.gameId + "/pictures/chars/" + charContent.picture;
	}
    }
    
    return (
	<TransitionGroup>
	    <CSSTransition timeout={1000} key={src} classNames="translate-left" appear>
		<div className={"position-absolute start-0 bottom-0"}>
		    {charId !== null && (<CharPicture charId={charId} height={"80vh"}/>)}
		</div>
	    </CSSTransition>
	</TransitionGroup>
    );
}
